import { render, staticRenderFns } from "./ResguardoArmamentoMuniciones.vue?vue&type=template&id=fcbfa95c"
import script from "./ResguardoArmamentoMuniciones.vue?vue&type=script&lang=js"
export * from "./ResguardoArmamentoMuniciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports